import { FetchUserRoleParam, PutUserRoleParam, UpdateMyPageDataRequest } from '@/Interfaces/I_userRole';

import { customAxios } from '../index';

// get user role
export const fetchUserRoleApi = (data: FetchUserRoleParam) =>
  customAxios({
    url: 'hktv_koc/cms/accounts/role',
    method: 'GET',
    params: data,
  });

export const putUserRoleApi = (data: PutUserRoleParam[]) =>
  customAxios({
    url: 'hktv_koc/cms/accounts/role',
    method: 'PUT',
    data,
  });

export const getMyPageUserProfileData = (uuid: string) =>
  customAxios({
    url: `hktv_koc/cms/accounts/myPageProfile?uuid=${uuid}`,
    method: 'GET',
  });

export const updateMyPageUserProfileData = (data: UpdateMyPageDataRequest) =>
  customAxios.post('hktv_koc/cms/accounts/myPageProfile', data);

export const getUserStreamerData = (uuid: string) =>
  customAxios({
    url: `hktv_koc/cms/accounts/streamer?uuid=${uuid}`,
    method: 'GET',
  });

export const updateUserStreamerData = (data: FormData) =>
  customAxios.post('hktv_koc/cms/accounts/streamer', data);

export const getStreamerBanner = (fileName: string) => customAxios.get(fileName);

export default fetchUserRoleApi;
